export const supportedLocales = ['fr', 'en', 'de'];

export function isLocale(tested?: string) {
  return supportedLocales.some((locale) => locale === tested);
}
